const configContents = ({
  state: {
    langStrings,
    loadingMoreThanRequired,
  },
  dispatch,
}) => {
  let processSpinInfo;

  if (loadingMoreThanRequired) {
    processSpinInfo = [
      langStrings
      ? langStrings.processingScreen.updatedMsgLonger
      : 'Still working on it',
      langStrings
      ? langStrings.processingScreen.takingLongerExpected
      : "It's taking longer than expected - sorry for the wait.",
    ];
  } else {
    processSpinInfo = [
      langStrings
        ? langStrings.processingScreen.firstMsg
        : 'Working on your request',
      langStrings
        ? langStrings.processingScreen.willTakeSecs
        : 'This might take a few seconds…',
    ];
  }

  setTimeout(() => {
    dispatch({ type: 'TAKING_MORE_THAN_REQUIRED' });
  }, 3000);

  return [
    {
      isSpin: true,
      paragraphStyle: { marginTop: '100px' },
      id: 'adsk-page-title',
    },
    {
      description: processSpinInfo[0],
      style: { fontSize: '26px', fontWeight: 400, color: '#333' },
      paragraphStyle: {
        marginTop: '20px',
        textAlign: 'center',
        marginBottom: '30px',
      },
    },
    {
      description: processSpinInfo[1],
      style: { fontSize: '14px', color: '#666' },
      paragraphStyle: { textAlign: 'center' },
    },
  ];
};

export default {
  configContents,
};
